import styled from "styled-components";

const Headline1 = styled.h1.attrs({
    className: "headline1",
})`
    color: ${props => props.color}
`
export default Headline1;
